import { createMiddleware } from "@tanstack/react-start";

/**
 * Équivalent de `attachSupabaseAuth` généré, mais avec un import dynamique
 * du client Supabase : ce dernier (auth + realtime, ~120 ko) ne fait ainsi
 * plus partie du bundle d'entrée du site public, qui n'en a jamais besoin.
 * Il n'est téléchargé qu'au premier appel de fonction serveur (back-office).
 */
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      return next({ headers: token ? { Authorization: `Bearer ${token}` } : {} });
    } catch {
      return next({ headers: {} });
    }
  },
);
